module.exports = __webpack_public_path__ + "img/blank.062d680c.png";